
import Moment from 'moment';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  name: 'ProcessInvitesRow'
})
export default class ProcessInvitesRow extends Vue {
  @Prop() readonly model: null | object;
  @Prop() readonly header: null | object;
  @Prop() readonly cell: null | object;

  get selected() {
    return this.$store.getters['invites/isSelected'](this.model);
  }

  set selected(val) {
    this.$store.commit('invites/select', {
      model: this.model,
      value: val
    });
  }

  get statusResponse() {
    return this.model.response ? this.model.response.status : {};
  }

  get candidate() {
    return this.model.candidate;
  }

  get responseId() {
    return this.model.response ? this.model.response.id : null;
  }

  get vacancy() {
    return this.model.vacancy;
  }

  get response() {
    return this.model.response;
  }

  get candidateFullName() {
    return !this.is_japan_locale
      ? [this.model.candidate.name, this.model.candidate.surname].join(' ')
      : [this.model.candidate.surname, this.model.candidate.name].join(' ');
  }

  get company() {
    return this.$store.getters['user/company'];
  }

  get createdDate() {
    return this.model.created_at ? Moment(this.model.created_at).format(this.dateFormat) : null;
  }

  get createdTime() {
    let format = this.company.time_format === 12 ? 'hh:mm a' : 'HH:mm';
    return this.model.created_at ? Moment(this.model.created_at, null, 'en').format(format) : null;
  }

  get is_japan_locale() {
    return this.$store.getters['locale/is_japan_locale'];
  }

  get dateFormat() {
    return this.is_japan_locale ? 'YYYY.MM.DD' : 'DD.MM.YYYY';
  }

  get invite_creator() {
    if (!this.model || !this.model.creator) {
      return '';
    }

    return !this.is_japan_locale
      ? this.model.creator.full_name
      : this.model.creator.full_name_reverse;
  }

  get is_unpaid() {
    if (!this.model || !this.model.response) {
      return false;
    }

    return this.model.response.is_paid === 0;
  }

  get response_route() {
    return {
      name: 'response',
      params: {
        id: this.responseId
      }
    };
  }

  get is_deleted_response() {
    return this.model.response ? this.model.response.is_deleted : null;
  }

  get is_deleted_by_admin_response() {
    return this.model.response
      ? this.model.response.is_deleted && this.model.response.is_deleted_by_admin
      : null;
  }
  get is_disabled() {
    return (
      this.is_unpaid ||
      this.is_deleted_response ||
      (this.visibility && !this.visibility.is_active) ||
      this.refusal
    );
  }

  get visibility() {
    return this.model.interview && this.model.interview.visibility
      ? this.model.interview.visibility
      : null;
  }

  get refusal() {
    return this.model.refusal;
  }
}
